import type { Query } from '@tanstack/react-query'

// Queries that are really calculations bound to an open form (cross-section
// and check-settings editors): refetching them would re-run the calculation
// and overwrite what the user is editing.
const FORM_BOUND_QUERY_MARKERS = new Set([
  'getCalcChecksForElement',
  'updateChecksMultiEdit',
  'updateChecksMultiEditCheckSettings',
])

/**
 * Whether a query shows data of the project the agent just changed: its key
 * names the project (as an element, or inside an orval URL key) -- except
 * the chat's own queries (refetching those would reload the running thread)
 * and the form-bound calculations.
 */
export const isRefreshedAfterProjectChange =
  (projectId: string) =>
  (query: Query): boolean => {
    const key = query.queryKey as unknown[]
    const [root] = key
    if (typeof root === 'string' && root.startsWith('/agent-runs')) return false
    if (key.some(part => typeof part === 'string' && FORM_BOUND_QUERY_MARKERS.has(part))) {
      return false
    }
    return key.some(part => typeof part === 'string' && part.includes(projectId))
  }
